import { GalleryImage } from "../../types/components/imageGallery";

export default function getImagesForColourWay(
  allImages: GalleryImage[],
  colourWayId: number | null | undefined,
): GalleryImage[] {
  const visibleImages = allImages.filter((image) => image.isVisible !== false);

  if (!colourWayId) {
    return visibleImages;
  }

  const colourImage = allImages.find(
    (image) => image.colourWayId === colourWayId,
  );

  if (!colourImage) {
    return visibleImages;
  }

  const remainingImages = visibleImages.filter(
    (image) => image.url !== colourImage.url && !image.isPrimary,
  );

  return [colourImage, ...remainingImages];
}
